import React from "react";
import _ from "lodash";
import { NavLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import classnames from "classnames";

import "./SettingsNavBar.scss";

export const SettingsNavBar = ({ tabs }) => {
  return (
    <div className="settings-navigation">
      {_.map(tabs, ({ id, url, translationKey }) => (
        <NavLink
          key={id}
          to={`/settings${url}`}
          className={({ isActive }) =>
            classnames("settings-navigation__button", {
              "settings-navigation__button--active": isActive,
            })
          }
        >
          <span className="settings-navigation__tab-title">
            <FormattedMessage id={translationKey} />
          </span>
          <span className={`settings-navigation__image image__${id}`} />
        </NavLink>
      ))}
    </div>
  );
};
